const getRegioFromCookie = () => {
  let pc;
  if (window.MEDIAHUIS && window.MEDIAHUIS.cookie) {
    const regionCookie = window.MEDIAHUIS.cookie.get('cor-mycity');

    if (regionCookie) {
      const regionObj = JSON.parse(regionCookie);
      if (regionObj.hierarchy === 10) {
        if (regionObj.zip && regionObj.zip.length > 0) {
          pc = regionObj.zip;
        }
      }
    }
  }

  return pc;
};

export default getRegioFromCookie;
